import { asis, noop } from '@proc7ts/primitives';
import { execZ } from './exec.js';
export function execZAll(executions, combine = asis) {
    return execZ(() => {
        const toAbort = new Set(executions);
        const abort = () => {
            for (const exec of toAbort) {
                exec.abort();
            }
            toAbort.clear();
        };
        let fail = (exec) => {
            fail = noop;
            toAbort.delete(exec);
            abort();
        };
        return {
            whenStarted() {
                return Promise.all(Array.from(toAbort, exec => exec.whenStarted()));
            },
            whenDone() {
                return Promise.all(Array.from(toAbort, exec => exec.whenDone().catch(error => {
                    fail(exec);
                    return Promise.reject(error);
                }))).then(combine);
            },
            abort,
        };
    });
}
//# sourceMappingURL=exec-all.js.map